import {serializedSizeBytes, formatBytes} from '../helpers'

let lastBytes = 0
const deltaThreshold = 50 * 1024 // 50 KB

export const sizeMonitorMiddleware = storeAPI => next => action => {
	const result = next(action)
	const bytes = serializedSizeBytes(storeAPI.getState())
	const delta = Math.abs(bytes - lastBytes)

	if (delta >= deltaThreshold) {
		// Limit frequency; adjust as needed
		const formatted = formatBytes(bytes)
		console.log(`[redux] store size: ${formatted} (Δ ${formatBytes(delta)}) after`, action.type)
		lastBytes = bytes
	}

	return result
}
